var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActionsDeleteNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8001 6.72448L11.4329 11.7507C11.3962 12.252 11.1712 12.7209 10.803 13.0632C10.4349 13.4054 9.9508 13.5957 9.44812 13.5957H5.85232C5.34958 13.5955 4.86552 13.4051 4.49736 13.0628C4.12919 12.7204 3.90419 12.2515 3.86752 11.7501L3.50032 6.72448M12.6089 4.83808H2.69092M9.91252 4.83748L9.61072 3.35188C9.56807 3.19271 9.4741 3.05205 9.34339 2.95171C9.21267 2.85136 9.05251 2.79694 8.88772 2.79688H6.41512C6.24974 2.79625 6.0888 2.85034 5.95737 2.95073C5.82595 3.05112 5.73142 3.19216 5.68852 3.35188L5.38912 4.83748M6.51112 8.06548V10.7703M8.53912 8.06548V10.7703",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsDeleteNew);
export default __webpack_public_path__ + "static/media/actions-delete-new.59f8cc713e2376891b6675d1f539ce17.svg";
export { ForwardRef as ReactComponent };